// เปิดเกม SETZERO mini (auto_minigame): ขอ launch token จาก xapi (เส้น v1 member/minigamelaunch)
// แล้วเปิดแท็บใหม่ — เปิดแท็บก่อน await กัน popup blocker
export async function launchMinigame() {
    const win = window.open('', '_blank');
    try {
        const res = await fetch(window.localStorage.getItem('apiurl') + 'member/minigamelaunch', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem('appid')
            },
            body: ''
        });
        const json = await res.json();
        if (json.statusCode === 200 && json.payload && json.payload.url) {
            if (win) win.location.href = json.payload.url;
            else window.open(json.payload.url, '_blank');
            return true;
        }
        if (win) win.close();
        alert(json.message || 'ไม่สามารถเปิดเกมได้');
    } catch (e) {
        if (win) win.close();
        alert('ไม่สามารถเปิดเกมได้');
    }
    return false;
}
